module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic_1.fc6eb105.eot";